import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink, useParams } from "react-router-dom";
import { Grid, Box, Alert, AlertTitle, Button } from "@mui/material";
import { getProfileId, getReputacion } from "../../actions/profile";
import { getUserbyId } from "../../actions/users";
import ProfileHeader from "../../components/user/publicProfile/ProfileHeader";
import ProfileSidebar from "../../components/user/publicProfile/ProfileSidebar";
import ProfileServiceList from "../../components/user/publicProfile/ProfileServiceList";
import ProfileProvidersList from "../../components/user/publicProfile/ProfileProvidersList";
import { Loading } from "../../components/common/Loading";

// Tu propio perfil se ve como lo ven los demás. Al dueño el servidor le manda todos sus datos, pero a otra persona solo el contacto que deja
// ver su preferencia `share` (`puedeVerContacto`: 0 Nadie · 1 Todos · 2 Miembros · 3 Conexiones; se muestra como lo ve quien no es conexión)
// y el celular si está confirmado
const comoLoVenLosDemas = (persona) => {
  const share = typeof persona.share === 'number' ? persona.share : 1;
  return {
    ...persona,
    contactoVisible: share === 1 || share === 2,
    tel: persona.telVerificado === true ? persona.tel : undefined,
  };
};

const PublicProfile = () => {
  const { idUsuario } = useParams();
  const yo = useSelector(state => state.user.user);
  const [profile, setProfile] = useState(null);
  const [user, setUser] = useState(null);
  const [reputacion, setReputacion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profileData, userData, reputacionData] = await Promise.all([
          getProfileId(idUsuario),
          getUserbyId(idUsuario),
          getReputacion(idUsuario)
        ]);
        setProfile(profileData);
        setUser(userData);
        setReputacion(reputacionData);
      } catch (error) {
        console.error("Error fetching public profile data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (idUsuario) {
      fetchData();
    }
  }, [idUsuario]);

  if (loading) {
    return <Loading />;
  }

  const esMiPerfil = Boolean(yo?._id) && String(yo._id) === String(user?._id);

  return (
    <Box className="public-profile-container" sx={{ mt: 13, mb: 8 }}>
      <ProfileHeader user={user}>
        {/* «Ver mi perfil público» lleva aquí: que se note que es la vista de los demás y desde dónde se cambia */}
        {esMiPerfil && (
          <Alert severity="info" sx={{ borderRadius: '12px', mb: 2 }}>
            <AlertTitle sx={{ fontWeight: 700 }}>Así te ven los demás</AlertTitle>
            Esta es la página que ven tus clientes y quien te busca. Para cambiar algo, edítalo en tu perfil.
            <Box mt={1.5}>
              <Button variant="contained" size="small" component={RouterLink} to="/mi-perfil" sx={{ textTransform: 'none', fontWeight: 700 }}>
                Editar mi perfil
              </Button>
            </Box>
          </Alert>
        )}
      </ProfileHeader>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {/* Left Sidebar */}
        <Grid size={{ xs: 12, md: 4, lg: 3.5 }}>
          <ProfileSidebar user={esMiPerfil ? comoLoVenLosDemas(user) : user} profile={profile} reputacion={reputacion} />
        </Grid>

        {/* Right Content Area */}
        <Grid size={{ xs: 12, md: 8, lg: 8.5 }}>
          <Box className="profile-content-right" sx={{ pl: { md: 2 } }}>
            {/* `key`: al pasar al perfil de otra persona (desde «Proveedores relacionados») sus secciones empiezan cerradas */}
            <ProfileServiceList key={idUsuario} profile={profile} user={user} />
          </Box>
        </Grid>
      </Grid>
      
      {/* Related Providers Module */}
      <ProfileProvidersList currentUserId={idUsuario} />
    </Box>
  );
};

export default PublicProfile;
